import { interpolateRecord } from './utils';

const darkPaper = {
  img: "url('/images/bkg-noise.webp')",
  size: '200px 200px',
  mixBlendMode: 'normal',
  opacity: '0.0625'
  // mixBlendMode: 'soft-light',
  // opacity: '0.325'
};

const lightPaper: typeof darkPaper = {
  img: "url('/images/light-bkg-noise.webp')",
  size: '256px 256px',
  mixBlendMode: 'normal',
  opacity: '0.06'
};

export const darkmodeTextureDefinitions = interpolateRecord(
  darkPaper,
  '--texture-paper-',
  color => color
);

export const pinkmodeTextureDefinitions = interpolateRecord(
  lightPaper,
  '--texture-paper-',
  color => color
);

export const lightmodeTextureDefinitions = interpolateRecord(
  lightPaper,
  '--texture-paper-',
  color => color
);

export const paperTextureCssVars = Object.keys(darkPaper).reduce(
  (acc, key) => {
    acc[key as keyof typeof darkPaper] = `var(--texture-paper-${key})`;
    return acc;
  },
  {} as typeof darkPaper
);
